export const GET_ALL_MESSAGES_SUCCESS = "GET_ALL_MESSAGES_SUCCESS";
export const GET_ALL_MESSAGES_ERROR = "GET_ALL_MESSAGES_ERROR";
